import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_113: FaireProductEntity = {
  token: "legacy_prod_abbott-113",
  type: "product",
  name: "Beehive Covered Pot",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/90e4a2c0c6b25344044134d2bef8fe867eec6bdc010ed11719930f5468ed341e.jpeg",
  priceDollars: 22,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
